import { useState } from 'react'
import type { Client } from '../monitoring/monitoringApi'

export type ModuleAccessUser = {
  id: string; fullName: string; email: string; role: string
  vigilanciaAllowed?: boolean; portariaAllowed?: boolean
}

type Props = {
  client: Client; users: ModuleAccessUser[]; linked: ModuleAccessUser[]; busy: boolean; initialUser?: ModuleAccessUser
  onClose: () => void
  onSave: (body: { userId: string; role: string; vigilanciaAllowed: boolean; portariaAllowed: boolean }) => void
}

export function ClientModuleAccessDialog({ client, users, linked, busy, onClose, onSave, initialUser }: Props) {
  const [selected, setSelected] = useState<ModuleAccessUser | null>(initialUser ?? null)
  const [vigilancia, setVigilancia] = useState(() => { const current = linked.find(item => item.id === initialUser?.id); return client.vigilanciaAllowed === false || current?.vigilanciaAllowed === false ? 'none' : current?.role || 'client' })
  const [portaria, setPortaria] = useState(() => client.portariaAllowed === true && linked.find(item => item.id === initialUser?.id)?.portariaAllowed === true)
  function choose(user: ModuleAccessUser) {
    const current = linked.find(item => item.id === user.id)
    setSelected(user)
    setVigilancia(client.vigilanciaAllowed === false || current?.vigilanciaAllowed === false ? 'none' : current?.role || 'client')
    setPortaria(client.portariaAllowed === true && current?.portariaAllowed === true)
  }
  return <div className="media-modal client-editor-modal">
    <section className="entity-dialog" role="dialog" aria-modal="true" aria-labelledby="module-access-title">
      <h2 id="module-access-title">Acessos de {client.name}</h2>
      {selected ? <form className="stack-form" onSubmit={event => {
        event.preventDefault()
        if (vigilancia === 'none' && !portaria) return
        onSave({ userId: selected.id, role: vigilancia === 'operator' ? 'operator' : 'client', vigilanciaAllowed: vigilancia !== 'none', portariaAllowed: portaria })
      }}>
        <strong>{selected.fullName}</strong>
        <label>Vigilância<select value={vigilancia} disabled={busy} onChange={event => setVigilancia(event.target.value)}>
          <option value="none">Sem acesso</option>
          {client.vigilanciaAllowed !== false && <><option value="client">Cliente · câmeras e gravações</option><option value="operator">Operador · câmeras, gravações e eventos</option></>}
        </select></label>
        <label>Portaria<select value={portaria ? 'admin' : 'none'} disabled={busy} onChange={event => setPortaria(event.target.value === 'admin')}>
          <option value="none">Sem acesso</option>
          {client.portariaAllowed === true && <option value="admin">Administrador do condomínio</option>}
        </select></label>
        <p>Administrar a Portaria não concede administração na Vigilância. Administradores da empresa mantêm seus acessos administrativos.</p>
        <div className="dialog-actions"><button type="button" disabled={busy} onClick={() => setSelected(null)}>Voltar</button><button className="compact-primary" disabled={busy || vigilancia === 'none' && !portaria}>{busy ? 'Salvando…' : 'Salvar acessos'}</button></div>
      </form> : <>
        <p>Escolha um usuário para definir Vigilância e Portaria separadamente.</p>
        <div className="selection-list">{users.map(user => {
          const current = linked.find(item => item.id === user.id)
          return <button key={user.id} disabled={busy} onClick={() => choose(user)}><span><strong>{user.fullName}</strong><small>{current ? `Vigilância: ${current.vigilanciaAllowed === false ? 'Sem acesso' : current.role === 'operator' ? 'Operador' : 'Cliente'} · Portaria: ${current.portariaAllowed ? 'Administrador do condomínio' : 'Sem acesso'}` : user.email}</small></span><b>Editar acessos</b></button>
        })}</div>
      </>}
      <div className="dialog-actions"><button disabled={busy} onClick={onClose}>Fechar</button></div>
    </section>
  </div>
}
